import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getFacebookScopePermissions } from '../../../../utilities/facebook';
import { GeckoFields, GECKO_UTILS } from 'ui';

class FacebookChannelForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instaPages: [],
      facebookPages: [],
      auth_token: '',
    };
  }
  propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
  };
  defaultProps = {
    onChange: () => { },
  };

  changeHandler(key, value) {
    const newValue =
      key === 'configuration.instagram_id' && value
        ? this.handleInstaAccountChange(value)
        : GECKO_UTILS.setNestedValue(this.props.value, key, value);
    const newNewValue = GECKO_UTILS.setNestedValue(
      newValue,
      'configuration.auth_token',
      this.state.auth_token
    );
    this.props.onChange(newNewValue);
  }

  componentDidMount() {
    this.initFB();
  }

  initFB() {
    if (window.FB) {
      this.checkLoginState();
    } else {
      setTimeout(() => {
        this.initFB();
      }, 200);
    }
  }

  getInstaAccounts(pages = []) {
    const instaPagesRequest = pages.map(
      (page) =>
        new Promise((resolve, reject) => {
          window.FB.api(
            `${page.id}?fields=instagram_business_account`,
            ({ instagram_business_account, error }) => {
              if (error) return reject(error);
              if (!instagram_business_account) return resolve(null);
              window.FB.api(
                `${instagram_business_account.id}?fields=username`,
                ({ username, id, error }) => {
                  return error
                    ? reject(error)
                    : resolve({ username, id, page_id: page.id });
                }
              );
            }
          );
        })
    );

    return Promise.all(instaPagesRequest).then((instaRequests) =>
      instaRequests.filter((request) => request !== null)
    );
  }

  checkLoginState() {
    window.FB.getLoginStatus((response) => {
      if (response.status === 'connected') {
        const auth_token = response.authResponse.accessToken;
        const userId = response.authResponse.userID;
        window.FB.api(`/${userId}/accounts`, ({ data }) => {
          const facebookPages = data.length ? data : [];
          this.getInstaAccounts(facebookPages).then((instaPages) => {
            this.setState({
              facebookPages,
              instaPages,
              auth_token:
                this.props.value.configuration.auth_token || auth_token,
            });
          });
        });
      }
    });
  }

  handleTitleChange(event) {
    const newValue = Object.assign({}, this.props.value, {
      name: event.target.value,
    });
    this.props.onChange(newValue);
  }

  handlePageChange(event) {
    const newValue = Object.assign({}, this.props.value, {
      selectedFBPage: event.target.value,
    });
    this.props.onChange(newValue);
  }

  getFbPageForInstaAccount(accountId) {
    return this.state.instaPages.find(
      (instaAccount) => instaAccount.id === accountId
    )?.page_id;
  }

  handleInstaAccountChange(value) {
    const selectedInstaAccount = value;
    const selectedFBPage = this.getFbPageForInstaAccount(selectedInstaAccount);

    const withInstaId = GECKO_UTILS.setNestedValue(
      this.props.value,
      'configuration.instagram_id',
      selectedInstaAccount
    );
    const withBothIds = GECKO_UTILS.setNestedValue(
      withInstaId,
      'configuration.page_id',
      selectedFBPage
    );

    return withBothIds;
  }

  renderFacebookPageSelector() {
    return (
      <div className="form-group">
        <label>Facebook Page:</label>
        <select
          className="form-control"
          onChange={this.handlePageChange.bind(this)}
          value={this.props.value.selectedFBPage}
        >
          <option value>Please select a page</option>
          {this.state.facebookPages.map((p) => {
            return (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            );
          })}
        </select>
      </div>
    );
  }

  renderInstagramAccountSelector() {
    return (
      <div className="form-group">
        <label>Instagram Business Account:</label>
        <select
          className="form-control"
          onChange={this.handleInstaAccountChange.bind(this)}
          value={this.props.value.selectedInstaAccount}
        >
          <option value>Please select an account</option>
          {this.state.instaPages.map((p) => {
            return (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            );
          })}
        </select>
      </div>
    );
  }

  renderFormContent() {
    if (
      this.props.value.type === 'facebook' &&
      this.state.facebookPages.length
    ) {
      return this.renderFacebookPageSelector();
    } else if (
      this.props.value.type === 'instagram' &&
      this.state.instaPages.length
    ) {
      return this.renderInstagramAccountSelector();
    } else {
      return (
        <a
          className="btn btn-primary"
          style={{ display: 'block', color: 'white' }}
          onClick={() => {
            window.FB.login(this.checkLoginState.bind(this), {
              scope: getFacebookScopePermissions()
            });
          }}
        >
          Login to Facebook
        </a>
      );
    }
  }

  render() {
    const facebookInput = {
      key: 'configuration.page_id',
      type: 'select',
      label: 'Facebook Page',
      width: 'col-xs-12',
      options: this.state.facebookPages.map((page) => ({
        label: page.name,
        value: page.id,
      })),
      disabledWhen: () =>
        !!this.props.value.id || this.props.value.type !== 'facebook',
      require: true,
    };

    const pageInput =
      this.props.value.type === 'instagram'
        ? [
          {
            key: 'configuration.instagram_id',
            type: 'select',
            label: 'Instagram Business Account',
            width: 'col-xs-12',
            options: this.state.instaPages.map((account) => ({
              label: account.username,
              value: account.id,
            })),
            disabledWhen: () =>
              !!this.props.value.id || this.props.value.type !== 'instagram',
            require: true,
          },
        ]
        : [facebookInput];

    const fields = [
      {
        key: 'name',
        type: 'text',
        label: 'Channel Title',
        width: 'col-xs-12',
        required: true,
      },
      ...pageInput,
    ];

    return this.state.auth_token ? (
      <GeckoFields
        fields={fields}
        values={this.props.value}
        handler={this.changeHandler.bind(this)}
      />
    ) : (
      <a
        className="btn btn-primary"
        style={{ display: 'block', color: 'white' }}
        onClick={() => {
          window.FB.login(this.checkLoginState.bind(this), {
            scope: getFacebookScopePermissions(),
          });
        }}
      >
        Login to Facebook
      </a>
    );
  }
}

export default FacebookChannelForm;
